import React from 'react'

export default function QuotasTab1() {
	return (
		<div>quotas tab</div>
	)
}
